require('vanilla-cookieconsent');
var cc = initCookieConsent();
cc.run({
	current_lang: 'en',
	autoclear_cookies: true,                   // default: false
	page_scripts: true,                        // default: false

	gui_options: {
		consent_modal: {
			layout: 'box',               // box/cloud/bar
			position: 'bottom right',     // bottom/middle/top + left/right/center
			transition: 'slide',           // zoom/slide
			swap_buttons: false            // enable to invert buttons
		},
		settings_modal: {
			layout: 'box',                 // box/bar
			// position: 'left',           // left/right
			transition: 'slide'            // zoom/slide
		}
	},

	onFirstAction: function(user_preferences, cookie){
		// callback triggered only once on the first accept/reject action
	},

	onAccept: function (cookie) {
		// callback triggered on the first accept/reject action, and after each page load
	},

	onChange: function (cookie, changed_categories) {
		// callback triggered when user changes preferences after consent has already been given
	},

	languages: {
		'en': {
			consent_modal: {
				title: 'We use cookies!',
				description: 'This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
				primary_btn: {
					text: 'Accept all',
					role: 'accept_all'              // 'accept_selected' or 'accept_all'
				},
				secondary_btn: {
					text: 'Let me choose',
					role: 'settings'        // 'settings' or 'accept_necessary'
				}
			},
			settings_modal: {
				title: 'Cookie preferences',
				save_settings_btn: 'Save settings',
				accept_all_btn: 'Accept all',
				reject_all_btn: 'Reject all',
				close_btn_label: 'Close',
				cookie_table_headers: [
					{col1: 'Name'},
					{col2: 'Domain'},
					{col3: 'Expiration'},
					{col4: 'Description'}
				],
				blocks: [
					{
						title: 'Cookie usage',
						description: 'These cookies ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/cookie-policy" class="cc-link">cookie policy</a>.'
					}, {
						title: 'Strictly necessary cookies',
						description: 'These cookies are essential for the proper functioning of the website. Without these cookies, the website would not work properly',
						toggle: {
							value: 'necessary',
							enabled: true,
							readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
						}
					}, {
						title: 'Analytics cookies',
						description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
						toggle: {
							value: 'analytics',     // your cookie category
							enabled: false,
							readonly: false
						},
						cookie_table: [             // list of all expected cookies
							{
								col1: '_gcl_au',
								col2: '.venturepropertiesuk.com',
								col3: 'Provided by Google Tag Manager to experiment advertisement efficiency of websites using their services.',
								col4: '3 months',
							},
							{
								col1: 'suid',
								col2: '.simpli.fi',
								col3: 'Simpli. fi sets this cookie to store a distinct session ID.',
								col4: '1 year',
							},
							{
								col1: 'test_cookie',
								col2: '.doubleclick.net',
								col3: 'The test_cookie is set by doubleclick.net and is used to determine if the user\'s browser supports cookies.',
								col4: '15 minutes',
							},
							{
								col1: 'IDE',
								col2: '.doubleclick.net',
								col3: 'Google DoubleClick IDE cookies are used to store information about how the user uses the website to present them with relevant ads and according to the user profile.',
								col4: '1 year 24 days',
							},
							{
								col1: 'ab',
								col2: '.agkn.com',
								col3: 'Owned by agkn, this cookie is used for targeting and advertising purposes.',
								col4: '1 year',
							},
							{
								col1: 'TapAd_TS',
								col2: '.tapad.com',
								col3: 'TapAd sets this cookie to track users across devices to enable targeted advertising.',
								col4: '2 months',
							},
							{
								col1: 'TapAd_DID',
								col2: '.tapad.com',
								col3: 'TapAd sets this cookie to offer personalized content, social media features, and traffic analysis for its retargeting of online advertising.',
								col4: '2 months',
							},
							{
								col1: 'anProfile',
								col2: '.pro-market.net',
								col3: 'This cookie is set by the provider pro-market.net. This cookie is used for personalizing online ads based on the behaviour of the online customers.',
								col4: '5 months 27 days',
							},
							{
								col1: 'u',
								col2: '.agkn.com',
								col3: 'This cookie is used by Bombora to collect information that is used either in aggregate form, to help understand how websites are being used or how effective marketing campaigns are, or to help customize the websites for visitors.',
								col4: '1 year',
							},
							{
								col1: 'audience',
								col2: '.spotxchange.com',
								col3: 'SpotXchange sets this cookie as a unique ID that tracks audiences internally. The cookie is used to limit the number of repetitive ads shown to the user.',
								col4: '1 month',
							},
							{
								col1: 'TapAd_3WAY_SYNCS',
								col2: '.tapad.com',
								col3: 'TapAd sets this cookie for data synchronization with advertising networks.',
								col4: '2 months',
							},
							{
								col1: 'bku',
								col2: '.bluekai.com',
								col3: 'Bluekai uses this cookie to build an anonymous user profile with data like the user\'s online behaviour and interests.',
								col4: '6 months',
							},
							{
								col1: 'bkpa',
								col2: '.bluekai.com',
								col3: 'Set by Bluekai, this cookie stores anonymized data about the users\' web usage in an aggregate form to build a profile for targeted advertising.',
								col4: '6 months',
							},
							{
								col1: 'anHistory',
								col2: '.pro-market.net',
								col3: 'The domain of this cookie is owned by Datonics. This cookie is used for tracking the visitor on multiple websites inorder to serve them with relevant advertisements .',
								col4: '1 month',
							},
							{
								col1: '__io_cid',
								col2: '.bfmio.com',
								col3: 'This cookie is set by the provider bfmio.com. This cookie is used for detecting where the video advertisement should be displayed on the website.',
								col4: '1 year',
							},
							{
								col1: 'uuid2',
								col2: '.adnxs.com',
								col3: 'The uuid2 cookie is set by AppNexus and records information that helps in differentiating between devices and browsers. This information is used to pick out ads delivered by the platform and assess the ad performance and its attribute payment.',
								col4: '3 months',
							},
							{
								col1: 'anj',
								col2: '.adnxs.com',
								col3: 'AppNexus sets the anj cookie that contains data stating whether a cookie ID is synced with partners.',
								col4: '3 months',
							},
							{
								col1: 'suid_legacy',
								col2: 'simpli.fi',
								col3: 'Collects information on user preferences and interaction with web-campaign content which is used on CRM-campaign-platforms used by website owners for promoting events or products.',
								col4: '1 year',
							},
							{
								col1: 'uid_syncd',
								col2: '.simpli.fi',
								col3: 'The domain of this cookie is owned by Simpli.fi. This cookie is used for targeted advertising based on visitor preferences.',
								col4: '7 days',
							},
							{
								col1: 'uid_syncd_secure',
								col2: '.simpli.fi',
								col3: 'No description available.',
								col4: '7 days',
							},
							{
								col1: '__141_cid',
								col2: '.bfmio.com',
								col3: 'No description available.',
								col4: '1 year',
							}
						]
					}, {
						title: 'More information',
						description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact-us">contact us</a>.',
					}
				]
			}
		}
	}
});